import { Injectable, NgZone } from '@angular/core';
import { navigation } from '../../app/navigation/navigation';
import { CcmcApiService } from './ccmc-api.service';
import { SpinnerService } from './spinner.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ErrorDialogComponent } from '../components/error-dialog/error-dialog.component';
import { SuccessDialogComponent } from '../components/success-dialog/success-dialog.component';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { catchError, filter } from 'rxjs/operators';
import { CustomErrorHandlerService } from './custom-error-handler.service';
import { AssetService } from './asset.service';
import { ActiveLosService } from './active-los.service';
import { environment } from 'src/environments/environment';
import { CCMCConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { CaptureDataService } from './capture-data.service';
import { AmplifyService } from './amplify.service';
import { GlobalSearchService } from './global-search.service';
import { TargetResponseDialogComponent } from '../components/target-response-dialog/target-response-dialog.component';
const { Buffer } = require('buffer');
import { MatSnackBar } from '@angular/material/snack-bar';
@Injectable({
  providedIn: 'root'
})
export class PremierCOService {
  dynamicNav: any = navigation;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };
  constructor(
    private dialog: MatDialog,
    private ccmcApiService: CcmcApiService,
    private router: Router,
    private spinnerService: SpinnerService,
    private zone: NgZone,
    private http: HttpClient,
    private customErrorHandlerService: CustomErrorHandlerService,
    private assetService: AssetService,
    private amplifyService: AmplifyService,
    private activeLosService: ActiveLosService,
    private captureDataService: CaptureDataService,
    private globalSearchService: GlobalSearchService,
    private snackBar: MatSnackBar
  ) {
    this.httpOptions.headers.append('Access-Control-Allow-Origin', '*');
    this.httpOptions.headers.append(
      'Access-Control-Allow-Methods',
      'POST, GET, OPTIONS, PUT'
    );
    this.httpOptions.headers.append('Accept', 'application/json');
  }
  /**
   * Send
   * @description Sends the loan to the Premier communicator
   * @memberof PremierCOService
   */
  send() {
    this.spinnerService.setShowSpinner(true);
    let userName = this.amplifyService.username;
    const exportObject = {
      content: {
        mapping: this.ccmcApiService.mapping,
        search: this.ccmcApiService.search,
        configurations: this.ccmcApiService.configurations,
        transactions: this.ccmcApiService.transactions,
        cognitoID: this.amplifyService.getCognitoId()
      },
      user: userName,
      assetID: this.assetService.getSelectedAssetId()
    };
    console.log(exportObject);
    this.export(exportObject).subscribe(async res => {
      console.log(res);
      const parsedResult = JSON.parse(JSON.stringify(res));
      if (parsedResult.error) {
        let statusMessage = "Ground Control failed to receive a response back from the communicator"
        if (parsedResult.error.statusMessage) {
          statusMessage = parsedResult.error.statusMessage
        }
        const errorMessage = {
          statusMessage: statusMessage,
          statusFlag: false
        };
        const dialogRef2 = this.zone.run(() => {
          this.dialog.open(TargetResponseDialogComponent, {
            data: errorMessage
          });
        });
        await this.ccmcApiService.logExportResponse({
          assetID: this.assetService.getSelectedAssetId(),
          loanNumber: this.getLoanNumber(),
          statusMessage: parsedResult.error,
          statusFlag: false
        });
      } else if (parsedResult.statusFlag === true) {
        this.openSnackBar('Success', 'Okay');
        let loanNumber;
        if (parsedResult.loanNumber) {
          loanNumber = parsedResult.loanNumber;
        } else {
          loanNumber = this.getLoanNumber();
        }
        const resultMessage = {
          statusMessage: parsedResult.statusMessage,
          loanNumber: loanNumber,
          statusFlag: true
        };
        await this.ccmcApiService.logExportResponse({
          assetID: this.assetService.getSelectedAssetId(),
          loanNumber: loanNumber,
          statusMessage: parsedResult.statusMessage,
          statusFlag: parsedResult.statusFlag
        });
        this.captureDataService.uploadS3File(this.ccmcApiService.mapping);
        this.activeLosService.activeLosService.loanBooked(parsedResult,
          JSON.parse(JSON.stringify(this.ccmcApiService.configurations)));
        this.ccmcApiService.mapping = undefined;
        this.ccmcApiService.coreSettings = undefined;
        this.ccmcApiService.conditions = undefined;
        this.ccmcApiService.mapping = undefined;
        this.ccmcApiService.supportValues = undefined;
        this.ccmcApiService.search = undefined;
        this.ccmcApiService.transactions = undefined;
        this.ccmcApiService.configurations = undefined;
        if (this.dynamicNav[1].children[1]) {
          this.dynamicNav[1].children[1].children = [];
        }
        this.dynamicNav[1].children[0].badge.title = undefined;
        const dialogRef = this.dialog.open(TargetResponseDialogComponent, {
          data: resultMessage
        });
        dialogRef.afterClosed().subscribe(result => {
          if (this.activeLosService.activeLos === 'encompass' || this.activeLosService.activeLos === 'bytepro') {
            this.router.navigate(['loan-lookup']);
          } else {
            this.router.navigate(['file-selector']);
          }
        });
      } else if (parsedResult.statusFlag === false) {
        if (parsedResult.content && parsedResult.content.mapping) {
          // Retrieve Validation From existing mapping object
          let existingMappingCopy = JSON.parse(
            JSON.stringify(this.ccmcApiService.mapping)
          );
          for (let mappingItem of parsedResult.content.mapping) {
            let existingMappingIndex = existingMappingCopy.findIndex(
              (obj: any) => obj.fieldID === mappingItem.fieldID
            );
            if (existingMappingIndex > -1) {
              if (existingMappingCopy[existingMappingIndex].validation) {
                mappingItem.validation =
                  existingMappingCopy[existingMappingIndex].validation;
              }
            }
          }
          this.ccmcApiService.mapping = parsedResult.content.mapping;
        }
        if (parsedResult.content && parsedResult.content.transactions) {
          this.ccmcApiService.transactions = parsedResult.content.transactions;
        }

        await this.ccmcApiService.logExportResponse({
          assetID: this.assetService.getSelectedAssetId(),
          loanNumber: this.getLoanNumber(),
          statusMessage: parsedResult.statusMessage,
          statusFlag: parsedResult.statusFlag
        });
        this.globalSearchService.initData();
        let message = parsedResult.statusMessage;
        if (message === '') {
          message = 'Loan send failed, please refer to logs.';
        }
        const errorMessage = {
          statusMessage: message,
          statusFlag: false
        };
        const dialogRef = this.dialog.open(TargetResponseDialogComponent, {
          data: errorMessage
        });
      } else {
        this.spinnerService.setShowSpinner(false);
        const errorMessage = {
          statusMessage: 'Loan send failed, please refer to logs.',
          statusFlag: false
        };
        const dialogRef = this.dialog.open(TargetResponseDialogComponent, {
          data: errorMessage
        });
      }
    });
  }
  /**
   * Customer Search
   * @description performs the customers search in the PremierCO communicator
   * @param {*} borrower
   * @param {*} callback
   * @memberof PremierCOService
   */
  customerSearch(borrower: any, callback: any) {
    let userName = this.amplifyService.username;
    const request = {
      content: borrower,
      assetID: this.assetService.getSelectedAssetId(),
      user: userName
    };
    console.log(request);
    request.content.cognitoID = this.amplifyService.getCognitoId();
    request.content.configurations = this.ccmcApiService.configurations;
    request.content.search = this.ccmcApiService.search;
    let organizationID = this.getOrganizationID();
    if (organizationID.length > 0) {
      request.content.organizationID = organizationID;
    }
    this.searchCustomer(request).subscribe(res => {
      console.log(res);
      this.spinnerService.setShowSpinner(false);
      const parsedResult = JSON.parse(JSON.stringify(res));
      // console.log(parsedResult.error);
      if (parsedResult.error) {
        const errorMessage = {
          message: JSON.stringify(parsedResult.error.message),
          title: 'PremierCO Result'
        };
        const dialogRef = this.dialog.open(ErrorDialogComponent, {
          data: errorMessage
        });
      }
      if (parsedResult.statusFlag === true) {
        const payload = parsedResult.content;
        if (payload.length > 0) {
          const searchResult = payload;
          console.log(searchResult);
          callback(searchResult);
        } else {
          const noResult = [
            {
              firstName: 'No Result',
              lastName: '',
              taxID: '',
              CIF: '',
              address: ''
            }
          ];
          const searchResult = noResult;
          console.log(searchResult);
          callback(searchResult);
        }
      } else if (parsedResult.statusFlag === false) {
        const errorMessage = {
          message: parsedResult.statusMessage,
          title: 'Search Error'
        };
        const dialogRef = this.dialog.open(ErrorDialogComponent, {
          data: errorMessage
        });
        dialogRef.afterClosed().subscribe(() => {
          callback(parsedResult.content);
        });
      }
    });
  }
  /**
   * Assign Borrowers
   * @description set the field value to the customer name
   * @param {*} party
   * @memberof PremierCOService
   */
  assignBorrowers(party: any) {
    console.log(party);
    for (let i = 0; i < party.length; i++) {
      console.log(party[i]);
      const CIFFields = party[i].CIFFields.split(',');
      CIFFields.forEach((cf: any) => {
        const cifIndex = this.ccmcApiService.mapping.findIndex(
          (f: any) => f.fieldID === cf.trim()
        );
        this.ccmcApiService.mapping[cifIndex].fieldValue = party[i].CIF;
      });
    }
  }
  /**
   * Search Customer
   * @description calls the search customer api
   * @param {*} params
   * @returns
   * @memberof PremierCOService
   */
  searchCustomer(params: any) {
    console.log(JSON.stringify(params));
    return this.http
      .post(
        `${Buffer.from(environment.environmentURL, "base64").toString()}/fiserv/premierco/search-customer`,
        params,
        this.httpOptions
      )
      .pipe(catchError(this.customErrorHandlerService.handleError));
  }
  /**
   * Export
   * @desciption call the export api
   * @param {*} params
   * @returns
   * @memberof PremierService
   */
  export(params: any) {
    console.log(params);
    return this.http
      .post(
        `${Buffer.from(environment.environmentURL, "base64").toString()}/fiserv/premierco/export-messages`,
        params,
        this.httpOptions
      )
      .pipe(catchError(this.customErrorHandlerService.handleError));
  }
  /**
   * auto Customer Search
   * @description performs the auto customers search in the horizon communicator
   * @param {*} borrower
   * @param {*} callback
   * @memberof IBSService
   */
  autoCustomerSearch(borrower: any, callback: any) {
    let userName = this.amplifyService.username;
    const request = {
      content: borrower,
      assetID: this.assetService.getSelectedAssetId(),
      user: userName
    };
    console.log('Request: \n', JSON.stringify(request));
    request.content.cognitoID = this.amplifyService.getCognitoId();
    request.content.configurations = this.ccmcApiService.configurations;
    request.content.search = this.ccmcApiService.search;
    let organizationID = this.getOrganizationID();
    if (organizationID.length > 0) {
      request.content.organizationID = organizationID;
    }
    this.searchCustomer(request).subscribe(res => {
      console.log('Customer search response: ', res);
      const parsedResult = JSON.parse(JSON.stringify(res));
      console.log(parsedResult);
      if (parsedResult.error) {
        const errorMessage = {
          message: JSON.stringify(parsedResult.error.statusMessage),
          title: 'PremierCO Result'
        };
        const dialogRef = this.dialog.open(ErrorDialogComponent, {
          data: errorMessage
        });
      }
      if (parsedResult.statusFlag === true) {
        this.spinnerService.setShowSpinner(false);
        const payload = parsedResult.content;
        if (payload.length > 0) {
          const searchResult = payload;
          console.log(searchResult);
          callback(searchResult);
        } else {
          const noResult = [
            {
              firstName: 'No Result',
              lastName: '',
              taxID: '',
              CIF: '',
              address: ''
            }
          ];
          const searchResult = noResult;
          console.log(searchResult);
          callback(searchResult);
        }
      } else if (parsedResult.statusFlag === false) {
        this.spinnerService.setShowSpinner(false);
        if (
          parsedResult.statusMessage
            .toLowerCase()
            .includes('no customer record found')
        ) {
          const noResult = [
            {
              firstName: 'No Result',
              lastName: '',
              taxID: '',
              CIF: '',
              address: ''
            }
          ];
          const searchResult = noResult;
          console.log(searchResult);
          callback(searchResult);
        } else {
          const errorMessage = {
            message: parsedResult.statusMessage,
            title: 'Search Error'
          };
          const dialogRef = this.dialog.open(ErrorDialogComponent, {
            data: errorMessage
          });
          callback(parsedResult);
        }
      }
    });
  }
  getLoanNumber() {
    console.log('get Loan number');
    let loanFieldIndex = this.ccmcApiService.mapping.findIndex(
      (obj: any) => obj.fieldID === '1014'
    );
    if (loanFieldIndex > -1) {
      // Return loan number
      console.log(
        'loan number',
        this.ccmcApiService.mapping[loanFieldIndex].fieldValue
      );
      return this.ccmcApiService.mapping[loanFieldIndex].fieldValue;
    }
  }

  getOrganizationID() {
    let organizationIDFieldID = 'OA00_0000';
    let organizationIDFieldIndex = this.ccmcApiService.mapping.findIndex(
      (obj: any) => obj.fieldID === organizationIDFieldID
    );
    if (organizationIDFieldIndex > -1) {
      // Return loan number
      console.log(
        'OrganizationID ',
        this.ccmcApiService.mapping[organizationIDFieldIndex].fieldValue
      );
      return this.ccmcApiService.mapping[organizationIDFieldIndex].fieldValue;
    }
    return '';
  }

  openSnackBar(message: string, action: string) {
    this.zone.run(() => {
      setTimeout(() => {
        this.snackBar.open(message, action, {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'center'
        });
      }, 0);
    });
  }
}